import { createContext, FC, ReactNode, useContext } from 'react';
import { ProcessReportModalProps } from './ProcessReportModal.props';
import useProcessReportModal from './useProcessReportModal';

type ProcessReportModalContextValue = ReturnType<typeof useProcessReportModal>;

const ProcessReportModalContext = createContext<ProcessReportModalContextValue | null>(null);

type ProcessReportModalProviderProps = Omit<ProcessReportModalProps, 'onClose'> & {
  children: ReactNode;
};

export const ProcessReportModalProvider: FC<ProcessReportModalProviderProps> = ({
  children,
  open,
  cmdId,
  valuationId,
  companyName,
  valuedEntityFolderPath,
  valuationFolderPath,
  existingReportReference,
}) => {
  const state = useProcessReportModal({
    open,
    cmdId,
    valuationId,
    companyName,
    valuedEntityFolderPath,
    valuationFolderPath,
    existingReportReference,
  });

  return (
    <ProcessReportModalContext.Provider value={state}>
      {children}
    </ProcessReportModalContext.Provider>
  );
};

export const useProcessReportModalContext = (): ProcessReportModalContextValue => {
  const context = useContext(ProcessReportModalContext);
  if (!context) {
    throw new Error('useProcessReportModalContext must be used within ProcessReportModalProvider');
  }
  return context;
};
